import * as React from 'react';

import { Button } from '../Button';

interface IHelpInSearchButtonProps {
  open(): void;
}

export function HelpInSearchButton({ open }: IHelpInSearchButtonProps) {
  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    open();
  };

  return (
    <Button normalText type="secondary" onClick={onClick}>Поможем найти быстрее</Button>
  );
}
